import { Component, EventEmitter, Input, Output } from '@angular/core';
import { highcharts } from '@lib/highcharts';
import * as Highcharts from 'highcharts';

interface ExecutiveChartOption {
	options: Highcharts.Options;
	widthClass: string;
}

@Component({
	selector: 'app-executive-chart-section',
	templateUrl: './executive-chart-section.component.html',
	styleUrls: ['./executive-chart-section.component.css']
})
export class ExecutiveChartSectionComponent {

	@Input() Highcharts: typeof highcharts = Highcharts;
	@Input() collapsible = false;
	@Output() chartInstance = new EventEmitter<{ event: Highcharts.Chart, index: number }>();

	private collapsedByIndex: boolean[] = [];
	private _chartOptionsList: ExecutiveChartOption[] = [];
	private _collapseStateKey = 'default';
	private readonly storageKeyPrefix = 'executive-chart-collapsed-state';

	@Input() set collapseStateKey(value: string) {
		this._collapseStateKey = value || 'default';
		this.syncCollapsedState();
	}

	@Input() set chartOptionsList(value: ExecutiveChartOption[]) {
		this._chartOptionsList = value ?? [];
		this.syncCollapsedState();
	}

	public get chartOptionsList(): ExecutiveChartOption[] {
		return this._chartOptionsList;
	}

	public onChartInstance(event: Highcharts.Chart, index: number) {
		this.chartInstance.emit({ event, index });
	}

	public isCollapsed(index: number): boolean {
		return this.collapsedByIndex[index] ?? false;
	}

	public hasCollapsedCharts(): boolean {
		return this.collapsedByIndex.some(Boolean);
	}

	public toggleCollapsed(index: number) {
		this.collapsedByIndex[index] = !this.isCollapsed(index);
		this.saveCollapsedState();
	}

	private getSavedCollapsedState(): boolean[] {
		return JSON.parse(localStorage.getItem(this.storageKey) ?? '[]');
	}

	private saveCollapsedState() {
		localStorage.setItem(this.storageKey, JSON.stringify(this.collapsedByIndex));
	}

	private syncCollapsedState() {
		const savedState = this.getSavedCollapsedState();
		this.collapsedByIndex = this._chartOptionsList.map((_, index) => savedState[index] ?? false);
	}

	private get storageKey(): string {
		return `${this.storageKeyPrefix}-${this._collapseStateKey}`;
	}
}
